<style>
  div.errorHeader {
    font-size: 9.375rem;
    color: #727477;
    font-weight: bold;
    line-height: 9rem;
    margin-top: -0.5rem;
  }

  #NotFoundContent h1 {
    font-weight: 700;
    color: #1B1B1B;
    font-size: 3.375rem;
    margin: 0 0 1rem 0;
    padding: 0;
  }

  .error-subHeader {
    color: #000;
    font-size: 1.25rem;
    line-height: 1.625rem;
    font-weight: bold;
    margin-top: 0;
  }

  div.rebrandColorLineContainer {
    width: 30%;
    margin: 2rem 0;
  }

  div.rebrandColorLine {
    border: 0;
    background-color: unset;
    box-shadow: none;
    font-weight: 600;
    border-bottom-width: 0.5rem;
    border-bottom-style: solid;
    border-bottom-color: transparent;
    border-image: linear-gradient(to right, transparent 3rem, #093453 3rem 100%) 100% 1;
    position: relative;
  }

    div.rebrandColorLine:before {
      content: '';
      border: none;
      position: absolute;
      width: 3rem;
      height: 0.5rem;
      background: -webkit-linear-gradient(left, #009dd2 33%, transparent 33% 50%, #d13038 50% 83%, transparent 83% 100%);
    }

  .grid-col-8 {
    width: 66.6666666667%;
    padding: 2rem 0;
  }

  .grid-container {
    margin-left: auto;
    margin-right: auto;
    max-width: 64rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .Buttons input[type=button], .Buttons input[type=submit] {
    width: auto;
  }

  @media (min-width: 64em) {
    .grid-container {
      padding-left: 2rem;
      padding-right: 2rem;
    }
  }

  @media (max-width: 1024px) {
    #NotFoundContent h1 {
      font-size: 1.6rem;
      line-height: 2.5rem;
    }
  }

  @media (max-width: 645px) {
    div.rebrandColorLineContainer {
      width: 40%;
    }
  }
</style>

<div class="grid-container">
  <div class="ErrorPage Error500 grid-col-8">
    <div id="NotFoundContent">
      <div class="errorHeader">404</div>
      <h1>Page Not Found</h1>
      <p class="error-subHeader">
        We're sorry, we can't find the page you're looking for. It might have been removed, changed its name, or is otherwise unavailable.
      </p><div class="rebrandColorLineContainer">
        <div class="rebrandColorLine"></div>
      </div>
      <p>
        If you typed the URL directly, check your spelling and capitalization. Our URLs look like this: https://www.opm.gov/.
      </p>
      <p>
        Visit our homepage for helpful tools and resources, or contact us and we'll point you in the right direction.
      </p>
      <p class="Buttons">
        <input id="btnHomepage" alt="Homepage" value="Visit Homepage" type="submit" onclick="window.location='/';">
        <input id="btnContactUs" value="About Us" type="submit" onclick="window.location='/about-us/';">
      </p>
      <p>For immediate assistance, call (202) 606-1800</p>
    </div>
  </div>
</div>
